module.exports = __webpack_public_path__ + "static/tax-banner.e1c73f42.jpg";